export const LOAD_ROLE_USER = 'LOAD_ROLE_USER';
export const CHANGE_DATA_ROLE = "CHANGE_DATA_ROLE"
export const UPDATE_ROLE_USER = 'UPDATE_ROLE_USER';